export const CHANGE_THEME_TO_DARK = 'CHANGE_THEME_TO_DARK';
export const CHANGE_THEME_TO_LIGHT = 'CHANGE_THEME_TO_LIGHT';
export const CHANGE_THEME_TO_SYSTEM = 'CHANGE_THEME_TO_SYSTEM';
export const SYNC_SYSTEM_THEME = 'SYNC_SYSTEM_THEME';

const rememberTheme = mode => {
  try {
    window.localStorage.setItem('kkutu-admin-theme', mode);
  } catch (e) {
    // Storage can be unavailable in private or restricted browser contexts.
  }
};

export function changeThemeToDark() {
  rememberTheme('dark');
  return {
    type: CHANGE_THEME_TO_DARK,
  };
}

export function changeThemeToLight() {
  rememberTheme('light');
  return {
    type: CHANGE_THEME_TO_LIGHT,
  };
}

export function changeThemeToSystem() {
  rememberTheme('system');
  return {
    type: CHANGE_THEME_TO_SYSTEM,
    dark: window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches,
  };
}

export function syncSystemTheme(dark) {
  return {
    type: SYNC_SYSTEM_THEME,
    dark,
  };
}
